/* eslint-disable react/prop-types */
import React from 'react';
import { Line, Text } from 'react-konva';
// const textureList = Object.keys(SoundBankOne);

function Grid ({ width, height, gridSize }) {
  // const cols = Math.ceil(width / gridSize);
  const rows = Math.ceil(height / gridSize);

  const lines = [];
  const labels = [];
  const fontSizeRatio = 1 / 30;
  const labelTexts = Array.from({ length: 25 }, (_, i) => i - 12).reverse(); // TODO: remvove hardcoded elements

  //   // Create vertical lines
  //   for (let i = 0; i <= cols; i++) {
  //     const x = i * gridSize;
  //     lines.push(<Line key={`v-${i}`} points={[x, 0, x, height]} stroke="#ccc" />);
  //   }

  // Create horizontal lines
  for (let i = 0; i <= rows; i++) {
    const y = i * gridSize;
    lines.push(<Line key={`h-${i}`} points={[0, y, width, y]} stroke="#ccc" />);
  }

  for (let row = 0; row <= rows; row++) {
    const x = 2;
    const y = row * gridSize + 2;
    const label = (
        <Text key={`row-${row}`} x={x} y={y} text={labelTexts[row]} align="right" verticalAlign="middle" fontSize={height * fontSizeRatio} />
    );
    labels.push(label);
  }

  return <React.Fragment>
    {lines}
    {labels}
    </React.Fragment>;
};

export default Grid;
